export const ROW_HEIGHT = 56;
export const ESTIMATED_HEADER_HEIGHT = 40;
export const MIN_COLUMN_SIZE = 100;
export const DEFAULT_COLUMN_WIDTH_PERCENTAGE = 18;
export const NAME_COLUMN_PERCENTAGE = 46;
export const MIN_NAME_COLUMN_SIZE = 280;
